/* ============================================================
   HIT: dados da vitrine ao vivo (PLANO, Tarefa 18). Lê o RESUMO DO CATÁLOGO, que a seção sections/resumo-catalogo.liquid
   imprime por Section Rendering, página a página de 250:
     <raiz da loja>collections/all?page=<n>&section_id=resumo-catalogo
   SEM filtro de estoque (D5, 19/10/2026): o resumo traz também os esgotados (disponivel false); quem não os quer usa V.estoque ou filtra
   por disponivel.
   Entrega as linhas no CONTRATO DO RESUMO (topo do assets/hit-vitrine.js, Tarefa 9). Sem DOM da página e sem texto de interface: as
   mensagens daqui são de erro técnico, para o console de quem desenvolve.

   USO
     HitDados.catalogo()  Promise das linhas (lista congelada, na ordem de idx, sem handle repetido).
     HitDados.vitrine()   Promise de HitVitrine.criar(linhas, HitConfig.vitrine) (precisa do hit-vitrine.js e do HitConfig do layout).
   QUEM CHAMA ESCONDE O BLOCO quando a promessa é rejeitada ou o desenho lança (PLANO, regra 4: bloco cujo dado falhou some, não mostra zero):
     HitDados.vitrine().then(desenha).catch(() => { bloco.hidden = true; });

   BUSCA. A página 1 diz quantas há (data-paginas); as demais vêm em seguida, no máximo 4 pedidos ao mesmo tempo. Cada página tem de trazer
   data-pagina = a pedida e uma lista. Mais de 40 páginas (10.000 produtos) não é catálogo desta loja: lê as 40 primeiras e avisa no console.
   As linhas saem na ordem de idx, e um handle repetido entre páginas (o produto que mudou de página entre dois pedidos) fica só com a
   PRIMEIRA cópia: a triagem do hit-vitrine.js descartaria as duas, e o produto sumiria da vitrine. O catálogo que encolhe entre os
   pedidos: a página além da última, vazia, conta como vazia. Um produto que mude de página entre os pedidos também pode FALTAR (sai da
   página ainda não lida e entra na já lida); volta na próxima busca.
   NOVA TENTATIVA: uma só por página, depois de 300 a 600 ms (ou do Retry-After), em HTTP 429, 5xx e erro de rede (TypeError do fetch).
   Outro 4xx e o aborto não se repetem. A espera tem de caber no que resta do prazo: se não cabe (um Retry-After de 120 s, ou a falha
   perto do fim), o erro sai na hora, sem esperar ("deu HTTP 429", e não "não chegou em 8 s"). O erro de rede sai como
   "HitDados: a página n não chegou (...)"; o AbortError sai como veio.
   PRAZO de 8 s para a busca inteira, novas tentativas incluídas: estourou, os pedidos são abortados e a promessa é rejeitada. Uma página
   que falha também aborta as outras.
   GUARDA. Em memória e em sessionStorage, na chave "hit-resumo-v1:<raiz da loja>:<moeda ativa>" ({ t, linhas }), por 10 minutos: a
   próxima página da mesma visita não busca de novo. MUDAR O CONTRATO DO RESUMO OBRIGA A TROCAR O v1 DA CHAVE: senão a visita lê, por
   até 10 min, linhas no formato velho. Lista vazia não é guardada. O sessionStorage pode faltar ou lançar (janela anônima, cota cheia,
   bloqueio do navegador): aí a guarda fica só na memória da página. Duas chamadas ao mesmo tempo dividem a mesma busca. Falha não fica
   guardada: a próxima chamada tenta de novo.
   VALIDADE de 10 min (risco aceito pela spec): o estoque e o preço da vitrine podem estar até 10 min atrás da loja (um produto que
   esgotou ainda aparece; um preço novo demora a aparecer). A página do produto e o carrinho mostram o de agora.
   AVISO das linhas que a triagem descartou: no console, com os handles, só quando o resumo veio de busca nova (uma vez por validade),
   nunca do que veio da guarda.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined' || window.HitDados) return; // carregado duas vezes: fica o primeiro (e a guarda dele)

  const SECAO = 'resumo-catalogo';
  const VERSAO = 'hit-resumo-v1'; // troque ao mudar o contrato do resumo. 19/10/2026 (esgotados + foto2, nota, cabeca) só ACRESCENTOU: a guarda de 10 min vence sozinha e as provas da home (F7) fixam esta chave
  const VALIDADE = 10 * 60 * 1000; // ms
  const PRAZO = 8000; // ms
  const MAX_PAGINAS = 40; // 10.000 produtos
  const SIMULTANEOS = 4; // pedidos ao mesmo tempo, depois da página 1
  const ESPERA = Object.freeze({ min: 300, max: 600 }); // ms antes da nova tentativa, sem Retry-After

  const shop = () => window.Shopify || {};
  const raiz = () => (shop().routes && shop().routes.root) || '/';
  const moeda = () => (shop().currency && shop().currency.active) || '';
  const chave = () => VERSAO + ':' + raiz() + ':' + moeda();
  const urlDa = (n) => raiz() + 'collections/all?page=' + n + '&section_id=' + SECAO;
  const falha = (msg) => new Error('HitDados: ' + msg);
  const congela = (o) => {
    if (o && typeof o === 'object' && !Object.isFrozen(o)) { Object.values(o).forEach(congela); Object.freeze(o); }
    return o;
  };
  const abortado = (sinal) => (sinal && sinal.reason) || Object.assign(new Error('a busca foi abortada'), { name: 'AbortError' });

  /* ---------- um pedido, com uma nova tentativa ---------- */
  /* espera ms; o aborto do sinal (prazo ou outra página que falhou) corta a espera */
  function espera(ms, sinal) {
    return new Promise((ok, nao) => {
      if (sinal && sinal.aborted) { nao(abortado(sinal)); return; }
      const t = setTimeout(ok, ms);
      if (sinal) sinal.addEventListener('abort', () => { clearTimeout(t); nao(abortado(sinal)); }, { once: true });
    });
  }
  /* o Retry-After da resposta (segundos ou data); sem ele, de 300 a 600 ms */
  function esperaDe(resp) {
    const ra = resp && resp.headers && typeof resp.headers.get === 'function' ? resp.headers.get('Retry-After') : null;
    const ms = ra == null ? NaN : /^\s*\d+(\.\d+)?\s*$/.test(ra) ? Number(ra) * 1000 : Date.parse(ra) - Date.now();
    return Number.isFinite(ms) ? Math.max(0, ms) : ESPERA.min + Math.random() * (ESPERA.max - ESPERA.min);
  }
  /* a nova tentativa da página n, se a espera cabe antes do fim do prazo (fim, em ms de Date.now); senão, o erro desta tentativa, já */
  async function repete(n, sinal, fim, ms, erro) {
    if (Date.now() + ms >= fim) throw erro;
    await espera(ms, sinal);
    return pede(n, sinal, fim, 1);
  }
  /* o texto da página n. Repete UMA vez em 429, 5xx e erro de rede; outro 4xx e o aborto não se repetem */
  async function pede(n, sinal, fim, tentativa) {
    let resp = null, texto = null;
    try {
      resp = await fetch(urlDa(n), { signal: sinal, credentials: 'same-origin' });
      if (resp.ok) texto = await resp.text();
    } catch (e) {
      if (e && e.name === 'AbortError') throw e;
      const erro = falha('a página ' + n + ' não chegou (' + (e && e.message ? e.message : e) + ')');
      if (tentativa === 0 && e && e.name === 'TypeError') return repete(n, sinal, fim, esperaDe(null), erro);
      throw erro;
    }
    if (resp.ok) return texto;
    const erro = falha('a página ' + n + ' do resumo deu HTTP ' + resp.status);
    if (tentativa === 0 && (resp.status === 429 || resp.status >= 500)) return repete(n, sinal, fim, esperaDe(resp), erro);
    throw erro;
  }

  /* ---------- uma página e as páginas juntas ---------- */
  /* uma página do resumo: { paginas, linhas }, ou lança dizendo o que veio errado */
  async function lePagina(n, sinal, fim) {
    const doc = new DOMParser().parseFromString(await pede(n, sinal, fim, 0), 'text/html');
    const ilha = doc.querySelector('script[data-resumo]');
    if (!ilha) throw falha('a página ' + n + ' veio sem o resumo (seção ' + SECAO + ')');
    const pagina = Number(ilha.getAttribute('data-pagina')), paginas = Number(ilha.getAttribute('data-paginas'));
    const marcada = () => falha('a página ' + n + ' veio marcada como ' + ilha.getAttribute('data-pagina') + ' de ' + ilha.getAttribute('data-paginas'));
    if (pagina !== n || !Number.isInteger(paginas) || paginas < 0) throw marcada();
    let linhas;
    try { linhas = JSON.parse(ilha.textContent); } catch (e) { throw falha('a página ' + n + ' tem JSON inválido (' + e.message + ')'); }
    if (!Array.isArray(linhas)) throw falha('a página ' + n + ' não traz uma lista');
    if (n > Math.max(1, paginas)) { // o catálogo encolheu entre os pedidos: além da última, só vale vazia
      if (linhas.length) throw marcada();
      return { paginas, linhas: [] };
    }
    return { paginas, linhas };
  }

  /* as páginas juntas, na ordem de idx (o que não tem idx numérico vai para o fim, e o hit-vitrine.js o descarta), sem handle repetido */
  function junta(listas) {
    const chaveDe = (r) => (r && Number.isFinite(r.idx) ? r.idx : Infinity);
    const todas = [].concat(...listas).sort((a, b) => (chaveDe(a) === chaveDe(b) ? 0 : chaveDe(a) < chaveDe(b) ? -1 : 1));
    const vistos = new Set();
    const unicas = todas.filter((r) => {
      const h = r && typeof r.handle === 'string' ? r.handle : null;
      if (h === null) return true; // fora do contrato: segue, e a triagem do hit-vitrine.js registra em V.descartadas
      if (vistos.has(h)) return false;
      vistos.add(h);
      return true;
    });
    return congela(unicas);
  }

  /* f(n) para cada n, no máximo `max` ao mesmo tempo, na ordem de ns; a primeira falha rejeita (e o comPrazo aborta as que correm) */
  async function emParalelo(ns, f, max) {
    const saida = [];
    let prox = 0;
    const vez = async () => {
      while (prox < ns.length) {
        const i = prox;
        prox += 1;
        saida[i] = await f(ns[i]);
      }
    };
    await Promise.all(Array.from({ length: Math.min(max, ns.length) }, vez));
    return saida;
  }

  async function busca(sinal, fim) {
    const primeira = await lePagina(1, sinal, fim);
    if (primeira.paginas > MAX_PAGINAS) console.warn('HitDados: o resumo diz ' + primeira.paginas + ' páginas; lidas as ' + MAX_PAGINAS + ' primeiras');
    const ns = [];
    for (let n = 2; n <= Math.min(primeira.paginas, MAX_PAGINAS); n += 1) ns.push(n);
    const demais = await emParalelo(ns, (n) => lePagina(n, sinal, fim), SIMULTANEOS);
    return junta([primeira, ...demais].map((p) => p.linhas));
  }

  /* a busca com prazo: estourado, ou com uma página que falhou, aborta os pedidos que ainda correm e rejeita. A tarefa recebe o sinal e
     o fim do prazo (ms de Date.now), para não começar uma espera que não cabe */
  function comPrazo(tarefa) {
    const ctl = typeof AbortController === 'function' ? new AbortController() : null;
    const fim = Date.now() + PRAZO;
    let relogio = null;
    const prazo = new Promise((ok, nao) => {
      relogio = setTimeout(() => nao(falha('o resumo não chegou em ' + PRAZO / 1000 + ' s')), PRAZO);
    });
    return Promise.race([tarefa(ctl ? ctl.signal : undefined, fim), prazo])
      .catch((e) => {
        if (ctl) ctl.abort();
        throw e;
      })
      .finally(() => clearTimeout(relogio));
  }

  /* ---------- guarda: memória e sessionStorage ---------- */
  let memoria = null; // { t, linhas }
  let emCurso = null;
  let novas = null; // as linhas da última busca nova: o aviso das descartadas sai uma vez, e nunca do que veio da guarda
  const fresca = (g) => !!g && Number.isFinite(g.t) && Date.now() - g.t >= 0 && Date.now() - g.t < VALIDADE && Array.isArray(g.linhas);
  function daSessao(k) {
    try {
      const g = JSON.parse(window.sessionStorage.getItem(k));
      return fresca(g) && g.linhas.length ? { t: g.t, linhas: junta([g.linhas]) } : null;
    } catch (e) {
      return null; // sem sessionStorage (ou com lixo na chave): busca de novo
    }
  }
  function guardaNaSessao(k, g) {
    try {
      window.sessionStorage.setItem(k, JSON.stringify({ t: g.t, linhas: g.linhas }));
    } catch (e) {
      // cota cheia ou armazenamento bloqueado: a guarda fica só na memória desta página
    }
  }

  function catalogo() {
    if (fresca(memoria)) return Promise.resolve(memoria.linhas);
    const k = chave(), daVisita = daSessao(k);
    if (daVisita) {
      memoria = daVisita;
      return Promise.resolve(memoria.linhas);
    }
    if (!emCurso) {
      emCurso = comPrazo(busca).then((linhas) => {
        if (linhas.length) { // lista vazia não é guardada: a próxima chamada busca de novo
          memoria = { t: Date.now(), linhas };
          guardaNaSessao(k, memoria);
          novas = linhas;
        }
        return linhas;
      }).finally(() => { emCurso = null; });
    }
    return emCurso;
  }

  /* a vitrine sobre as linhas: rejeita sem o hit-vitrine.js ou o HitConfig, com cfg errada (TypeError do criar) e sem produto com estoque.
     Linha fora do contrato não derruba: vai para V.descartadas (aviso no console só na busca nova). A mesma lista devolve a mesma vitrine */
  let ultima = null; // { linhas, V }
  function vitrine() {
    return catalogo().then((linhas) => {
      if (ultima && ultima.linhas === linhas) return ultima.V;
      if (!window.HitVitrine || !window.HitConfig) throw falha('a vitrine precisa do hit-vitrine.js e do HitConfig do layout');
      const V = window.HitVitrine.criar(linhas, window.HitConfig.vitrine);
      if (linhas === novas) {
        novas = null;
        const fora = V.descartadas.map((d) => d.handle);
        if (fora.length) console.warn('HitDados: ' + fora.length + ' linha(s) do resumo fora do contrato: ' + fora.join(', '), V.descartadas);
      }
      if (V.vazio) throw falha('o resumo não tem nenhum produto com estoque');
      ultima = { linhas, V };
      return V;
    });
  }

  window.HitDados = Object.freeze({ catalogo, vitrine, chave, SECAO, VERSAO, VALIDADE, PRAZO, MAX_PAGINAS, SIMULTANEOS });
})();
